// readmore readless javascript

  const toggleContainers = document.querySelectorAll('[data-toggle]');
   toggleContainers.length && toggleContainers.forEach(container => {
    const toggleButton = container.querySelector('.readmore__toggle');
    const moreText = container.querySelector('.readmore__more');
    toggleButton.addEventListener('click', function() {
      if (moreText.style.display === "none") {
        moreText.style.display = "inline";
        toggleButton.textContent = "Read Less";
      } else {
        moreText.style.display = "none";
        toggleButton.textContent = "Read More";
      }
    });
  });
